// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__-FUfP","row":"ProcedureTreatmentSummary_row__1UrKk"};